import React from 'react';
import { getVersion } from '@syncfusion/ej2-base';

const Footer = () => {
  const { REACT_APP_APP_VERSION } = process.env;
  return (
    <div className="mt-8 md:mt-24">
      <p className="dark:text-gray-200 text-gray-700 text-center m-6 md:m-20">
        © 2024-{(new Date().getFullYear())} All rights reserved by Zackat Labs
        <br />v.{REACT_APP_APP_VERSION} s.{getVersion()}
      </p>
    </div>
  );
};

export default Footer;
